import { Link } from "react-router-dom";

export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <path d="M32 6 L56 32 L32 58 L8 32 Z" fill="none" stroke="#E11D48" strokeWidth="3.5" />
    <path d="M32 16 L46 32 L32 48 L18 32 Z" fill="#E11D48" opacity="0.14" />
    <path d="M27 23 L42 32 L27 41 Z" fill="#E11D48" />
  </svg>
);

export const Logo = () => (
  <Link to="/" data-testid="brand-logo-link" className="group flex items-center gap-3">
    <span className="transition-transform duration-500 group-hover:rotate-90">
      <LogoMark />
    </span>
    <span className="leading-none">
      <span className="font-serif-d text-lg font-semibold tracking-tight text-white">
        best<span className="italic text-rose-500">porn</span>videos
      </span>
      <span className="block font-mono-d text-[10px] tracking-[0.3em] text-slate-400">.COM.BR · 18+</span>
    </span>
  </Link>
);
